import post from '../postService'
import URL from '../../Constants/apiUrls'

export default async function updateWOStatus(reqData) {
  try {
    const res = await post(`${URL.updateWOStatus}`, reqData)
    return res.data
  } catch (error) {
    return error
  }
}
